
(function(){
  function initSizeCalculator(){
  // Waist-based chart + US size. Source of truth = cm; inches + US for display. XS added 2026-08-18.
  var SIZES = [
    {label:"XS",  us:"0-2",   cmin:64,  cmax:69,  imin:25, imax:27},
    {label:"S",   us:"4-6",   cmin:71,  cmax:74,  imin:28, imax:29},
    {label:"M",   us:"8-10",  cmin:76,  cmax:81,  imin:30, imax:32},
    {label:"L",   us:"12-14", cmin:86,  cmax:94,  imin:34, imax:37},
    {label:"XL",  us:"16-18", cmin:99,  cmax:104, imin:39, imax:41},
    {label:"2XL", us:"20-22", cmin:107, cmax:112, imin:42, imax:44},
    {label:"3XL", us:"24-26", cmin:114, cmax:118, imin:45, imax:46},
    {label:"4XL", us:"28-30", cmin:119, cmax:122, imin:47, imax:48},
    {label:"5XL", us:"32-34", cmin:124, cmax:127, imin:49, imax:50}
  ];
  var overlay = document.getElementById('sbz-modal');
  if(overlay && overlay.dataset.sbInitialized) return;
  if(!overlay) return;
  window.sbSizeCleanup?.();
  overlay.dataset.sbInitialized='true';
  overlay.setAttribute('role','dialog'); overlay.setAttribute('aria-modal','true'); overlay.setAttribute('aria-label','Find your perfect fit');
  overlay.addEventListener('keydown',function(e){ if(e.key!=='Tab')return; var controls=Array.from(overlay.querySelectorAll('button,input,a[href]')).filter(n=>n.getClientRects().length&&!n.disabled); if(!controls.length)return; var first=controls[0],last=controls[controls.length-1]; if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();} });
  var calcUnit='in', chartUnit='in';
  function $(s){ return overlay.querySelector(s); }
  function $$(s){ return Array.prototype.slice.call(overlay.querySelectorAll(s)); }

  var opener=null, previousOverflow='';
  function open(){ opener=document.activeElement; previousOverflow=document.body.style.overflow; overlay.hidden=false; document.body.style.overflow='hidden'; overlay.querySelector('button, input')?.focus(); }
  function close(){ overlay.hidden=true; document.body.style.overflow=previousOverflow; if(opener?.isConnected) opener.focus(); }
  function handleClick(e){
    if(e.target.closest('[data-sbz-open]')){ open(); }
    else if(e.target.closest('[data-sbz-close]') || e.target===overlay){ close(); }
    else if(e.target.closest('.sb-cta-scroll-bundle')){ e.preventDefault(); scrollToBundle(); }
  }
  function handleKey(e){ if(e.key==='Escape' && !overlay.hidden) close(); }
  document.addEventListener('click',handleClick);
  document.addEventListener('keydown',handleKey);
  window.sbSizeCleanup=function(){ if(!overlay.hidden) close(); document.removeEventListener('click',handleClick); document.removeEventListener('keydown',handleKey); delete overlay.dataset.sbInitialized; };

  function showTab(name){
    $$('.sbz-tab').forEach(function(t){ t.classList.toggle('is-active', t.getAttribute('data-sbz-tab')===name); });
    $$('.sbz-pane').forEach(function(p){ p.classList.toggle('is-active', p.getAttribute('data-sbz-pane')===name); });
  }
  $$('.sbz-tab').forEach(function(tab){ tab.addEventListener('click', function(){ showTab(tab.getAttribute('data-sbz-tab')); }); });

  $$('.sbz-unit').forEach(function(group){
    var key = group.getAttribute('data-sbz-unit-group');
    group.querySelectorAll('.sbz-u').forEach(function(btn){
      btn.addEventListener('click', function(){
        group.querySelectorAll('.sbz-u').forEach(function(b){ b.classList.toggle('is-active', b===btn); });
        var u = btn.getAttribute('data-sbz-u');
        if(key==='calc'){ calcUnit=u; $('[data-sbz-suffix]').textContent=u; }
        if(key==='chart'){ chartUnit=u; renderTable(); }
      });
    });
  });

  // Works in CM. Arbitrates UPWARD: shared boundary returns the larger size,
  // and a measurement in a gap between two rows rounds up to the next size.
  function recommend(waistCm){
    var smallest = SIZES[0], largest = SIZES[SIZES.length-1];
    if(waistCm < smallest.cmin) return {size:smallest, status:'below'};
    if(waistCm > largest.cmax) return {size:largest, status:'above'};
    var match = null;
    for(var i=0;i<SIZES.length;i++){
      var s = SIZES[i];
      if(waistCm >= s.cmin && waistCm <= s.cmax){ match = s; }
    }
    if(match) return {size:match, status:'exact'};
    for(var j=0;j<SIZES.length;j++){
      if(SIZES[j].cmin > waistCm) return {size:SIZES[j], status:'between'};
    }
    return {size:largest, status:'exact'};
  }

  function runCalc(){
    var err=$('[data-sbz-error]'), res=$('[data-sbz-result]');
    err.hidden=true; res.hidden=true;
    var raw=($('#sbz-waist').value||'').toString().trim().replace(',', '.');
    var v=/^[+-]?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i.test(raw) ? Number(raw) : NaN;
    if(isNaN(v) || v<=0){ err.textContent='Please enter your waist measurement.'; err.hidden=false; return; }
    var waistCm = calcUnit==='cm' ? v : v*2.54;
    if(waistCm<45 || waistCm>180){ err.textContent='That measurement looks off, please double-check.'; err.hidden=false; return; }
    var r = recommend(Math.round(waistCm));
    var smallest = SIZES[0], largest = SIZES[SIZES.length-1];
    var note;
    if(r.status==='above'){
      var supportEmail=overlay.dataset.sbSupportEmail||'';
      var contact=/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(supportEmail) ? "Email us at " + supportEmail + " and we'll help you get it right before you order." : "Contact our support team through the contact page for help before you order.";
      note = "Your measurement is above our largest size, so " + largest.label + " is the biggest fit we offer. " + contact;
    } else if(r.status==='below'){
      note = "Your measurement is below our smallest size, so " + smallest.label + " is the closest fit we offer.";
    } else if(r.status==='between'){
      note = "You're between two sizes, so we've rounded up to " + r.size.label + " for the most comfortable fit.";
    } else {
      note = "Based on your waist, this is your best fit. Prefer a softer feel? You can size up.";
    }
    var guar = '<p class="guar">&#10003; Backed by our 90-day fit guarantee. Wrong size? We\'ll send the right one, free.</p>';
    var noteNode=document.createElement('p');noteNode.className='note';noteNode.textContent=note;
    res.innerHTML = '<p class="lbl">We recommend</p><div class="sz">'+r.size.label+'</div><p class="us">US '+r.size.us+'</p>'+noteNode.outerHTML+guar;
    res.hidden=false;
  }
  $('[data-sbz-calc]').addEventListener('click', runCalc);
  $('#sbz-waist').addEventListener('keydown', function(e){ if(e.key==='Enter'){ e.preventDefault(); runCalc(); } });

  function range(s){
    if(chartUnit==='cm'){ return s.cmin+'-'+s.cmax+' cm'; }
    return (s.imin===s.imax ? s.imin : s.imin+'-'+s.imax)+' in';
  }
  function renderTable(){
    var head='<tr><th>Size</th><th>US</th><th>Waist</th></tr>';
    var body=SIZES.map(function(s){ return '<tr><td>'+s.label+'</td><td>'+s.us+'</td><td>'+range(s)+'</td></tr>'; }).join('');
    $('[data-sbz-table]').innerHTML='<table class="sbz-table"><thead>'+head+'</thead><tbody>'+body+'</tbody></table>';
  }
  renderTable();

  function scrollToBundle(){
    var target = document.querySelector('.product__title, .product-title, .product-single__title, h1');
    if(target){ var top = target.getBoundingClientRect().top + window.pageYOffset - 120; window.scrollTo({top:top, behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'}); }
  }
  function goToBundle(){ close(); scrollToBundle(); }

  var bundleBtn = $('[data-sbz-bundle]');
  if(bundleBtn){ bundleBtn.addEventListener('click', goToBundle); }
  var altLink = $('[data-sbz-nomeasure]');
  if(altLink){ altLink.addEventListener('click', goToBundle); }
  }
  initSizeCalculator();
  document.addEventListener('shopify:section:load',initSizeCalculator);
  document.addEventListener('shopify:section:unload',function(e){ if(e.target.querySelector('#sbz-modal')) window.sbSizeCleanup?.(); });
})();
